/**
 * Stable domain error codes for business-level failures.
 * Extend this object as new flows need explicit classification.
 */
export const DOMAIN_ERROR_CODES = {
  AUTH_INVALID_CREDENTIALS: "AUTH_INVALID_CREDENTIALS",
  /** OAuth register attempt when brand row already exists */
  AUTH_USER_ALREADY_REGISTERED: "AUTH_USER_ALREADY_REGISTERED",
  /** OAuth login when user has no brand (not registered in app) */
  AUTH_ACCOUNT_NOT_REGISTERED: "AUTH_ACCOUNT_NOT_REGISTERED",
  /** signUp succeeded but `user` missing in response */
  AUTH_REGISTRATION_NO_USER: "AUTH_REGISTRATION_NO_USER",
  /** signIn succeeded but session/user payload incomplete */
  AUTH_LOGIN_NO_SESSION: "AUTH_LOGIN_NO_SESSION",
  /** Edge function succeeded but response shape invalid */
  AUTH_PAYMENT_LINK_MISSING: "AUTH_PAYMENT_LINK_MISSING",
  VALIDATION_FAILED: "VALIDATION_FAILED",
} as const;

export type DomainErrorCode = (typeof DOMAIN_ERROR_CODES)[keyof typeof DOMAIN_ERROR_CODES];
